import { RegistryPackageDocsPage } from '@/graphql/upbound-graphql';

function findDocsPageUrl({
  tableOfContents,
  requestedPageName,
}: {
  tableOfContents: Array<RegistryPackageDocsPage>;
  requestedPageName: string | undefined;
}): RegistryPackageDocsPage {
  if (!requestedPageName) {
    return tableOfContents[0];
  }

  const requestedPage = tableOfContents.find(
    ({ name }) => name.toLowerCase().replace(' ', '-') === requestedPageName.toLowerCase(),
  );

  if (!requestedPage) {
    return tableOfContents[0];
  }

  return requestedPage;
}

export { findDocsPageUrl };
